<template>
  <div class="password-panel">
    <div class="panelheader">
      <div class="title">Change Password</div>
    </div>
    <div class="data">
      <el-form :model="user" ref="resetForm">
        <el-form-item label="Current Password" prop="currPass">
          <el-input v-model="password.cur" class="pass-reset" type="password"></el-input>
        </el-form-item>
        <el-form-item label="New Password" prop="newPass">
          <el-input v-model="password.new" class="pass-reset" type="password"></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password" prop="checkPass">
          <el-input v-model="password.new2" class="pass-reset" type="password"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="save" v-on:click="resetPassword">Submit</el-button>
    </div>
  </div>
</template>

<script>
import auth from '../auth';
import { isValidPassword } from '../validator'

export default {
  name: 'change-password',
  data() {
    return {
      password: {
        cur:'',
        new:'',
        new2:''
      },
      user: {}
    }
  },
  beforeMount(){
    var id = JSON.parse(auth.getProfile()).user_id;
    var header = {headers: auth.getAuthHeader()};
    var uri = auth.getApi();
    this.$http.get(uri + '/api/user', {headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
      var profile = result.body.data;
      this.user = profile;
    });
  },
  methods: {
    resetPassword(){
      var context = this;

      var header = {headers: auth.getAuthHeader()};
      var data = this.password;
      var id = JSON.parse(auth.getProfile()).user_id;
      var uri = auth.getApi();

      this.$http.put(uri + '/api/user/password/reset/' + id, data, {headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{

        context.$emit('success');

        context.$refs['resetForm'].resetFields()

        context.$message({
          showClose: true,
          type: 'success',
          message: 'Successfully updated password'
        });


      }).catch(err => {

        context.$message({
          showClose: true,
          type: 'error',
          message: err.body.msg
        })

      })
    },
  }
}
</script>

<style>
  .password-panel {
    margin: auto;
  }
  
  .pass-reset {
    text-align: left;
  }
  
  .pass-reset .el-input__inner {
    width: 80%;
  }
  
  .password-panel .data {
    padding-left: 40pt !important;
    text-align: left;
    background-color: white;
    padding: 8pt;
  }
  
</style>



// WEBPACK FOOTER //
// ChangePassForm.vue?2de5631c